<p>scouts-firmware works!</p>
